import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Select, theme } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

const { useToken } = theme;

const GlobalTooltipStylesBase = createGlobalStyle<IToken>`
  .ant-checkbox-inner {
    border: 2px solid ${(props) =>
      props.token?.colorText || '#000000'} !important;
    background-color: ${(props) =>
      props.token?.colorBgContainer || '#ffffff'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }
  
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) =>
      props.token?.colorBgContainer || '#ffffff'} !important;
    border-color: ${(props) => props.token?.colorText || '#000000'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }
  
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border: 3px solid ${(props) =>
      props.token?.colorText || '#000000'} !important;
    border-top: 0 !important;
    border-left: 0 !important;
    opacity: 1 !important;
    display: block !important;
    width: 5px !important;
    height: 10px !important;
    transform: rotate(45deg) !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    margin-top: -6px !important;
    margin-left: -2px !important;
  }
  
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${(props) => props.token?.colorText || '#000000'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }
  
  .ant-checkbox-checked:hover .ant-checkbox-inner {
    border-color: ${(props) => props.token?.colorText || '#000000'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }

  .ant-table-filter-dropdown .ant-dropdown-menu-item,
  .ant-table-filter-dropdown .ant-dropdown-menu-item span {
    color: ${(props) => props.token?.colorText || '#000000'} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link {
    color: ${(props) => props.token?.colorPrimary || '#1677ff'};
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link span {
    color: ${(props) => props.token?.colorPrimary || '#1677ff'};
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link:disabled,
  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link:disabled span {
    color: ${(props) => props.token?.colorText || '#000000'};
  }
`;

export const GlobalTooltipStyles: React.FC = () => {
  const { token } = useToken();
  return <GlobalTooltipStylesBase token={token} />;
};

export const FilterSelect = styled(Select)`
  width: 150px;
  margin-right: 8px;
`;

export const LastFilterSelect = styled(Select)`
  width: 150px;
`;

export const ContentWrapper = styled.div`
  padding: 20px;

  .ant-table-wrapper .ant-table {
    .ant-table-filter-column {
      flex-direction: row-reverse;

      .ant-dropdown-trigger {
        margin-inline: 0 5px;
        color: white;
      }
    }
    .ant-table-content {
      border-radius: 10px;
    }
    .ant-table-thead tr .ant-table-cell {
      white-space: nowrap;
      padding: 0px 8px !important;
      height: 0px;
      line-height: 0px;
    }

    .ant-table-thead > tr:nth-child(2) > th {
      padding: 0;
      height: 0;
      line-height: 0;
      border: 0;
    }

    .ant-table-thead > tr:nth-child(2) > th::before {
      display: none;
      content: none;
    }

    .ant-table-tbody .ant-table-cell-fix-left {
      background-color: inherit !important;
    }
  }
`;

export const AddRowArea = styled.div`
  margin-top: 16px;
  text-align: center;
`;
